import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Rules, Services } from "./components/rules";
import { Sponsors } from "./components/sponsors";
import { Impressum } from "./components/impressum";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Recipient } from "./components/recipient";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} verkaufsstellen={landingPageData.Verkaufsstellen} />
      <Rules data={landingPageData.Rules} />
      <Recipient data={landingPageData.Recipient} />
      <Sponsors data={landingPageData.Sponsors} />
      <About data={landingPageData.About} />
      <Impressum data={landingPageData.Impressum} />
    </div>
  );
};

export default App;
